//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
import getFilePreviewPath from '../../../utils/pathUtil/getFilePreviewPath';
import getFileName from '../../../utils/pathUtil/getFileName';
import getFileThumbnailPath from '../../../utils/pathUtil/getFileThumbnailPath';
/**
 * @typedef {object} Data
 * @property {object} Path
 *
 * @typedef {object} Props
 * @property {Data} data
 * @param {Props} props
 */

var PlainNameFormatter = function PlainNameFormatter(_ref) {
  var data = _ref.data;
  return React.createElement(Formatter.Link, {
    icon: {
      path: data.Path
    },
    text: getFileName(data.Path),
    color: "inherit"
  });
};
/**
 * @typedef {object} Data2
 * @property {string} Path
 * @property {string} Workspace
 *
 * @typedef {object} Props2
 * @property {Data2} data
 *
 * @param {Props2} props
 */


var NameFormatter = function NameFormatter(_ref2) {
  var data = _ref2.data;
  return React.createElement(Formatter.Link, {
    icon: {
      path: data.Path
    },
    text: getFileName(data.Path),
    value: getFilePreviewPath({
      workspace: data.Workspace,
      path: data.Path
    })
  });
};

var columns = [{
  id: 'Path',
  formatter: NameFormatter,
  modes: ['detail']
}, {
  id: 'Template',
  children: 'Template',
  formatter: PlainNameFormatter,
  modes: ['list']
}];
var thumbnail = {
  url: function url(data) {
    return getFileThumbnailPath({
      path: data.Path,
      workspace: data.Workspace,
      token: data.ResourceToken
    });
  },
  text: function text(data) {
    return getFileName(data.Path);
  },
  icon: function icon(data) {
    return {
      path: data.Path
    };
  }
};
var placeholders = {
  label: function label(data) {
    return data ? data.Path : '';
  }
};
var data = {
  url: '/backend/projects/{projectId}/templates',
  dataKey: 'projectTemplates',
  idKeyProp: 'Path',
  onBeforeRequest: function onBeforeRequest(_ref3, request) {
    var projectId = _ref3.dataProps.projectId;
    return {
      url: request.url.replace('{projectId}', projectId)
    };
  }
};
export default {
  columns: columns,
  thumbnail: thumbnail,
  data: data,
  placeholders: placeholders
};